import React from "react";
import { Send, FileUp, ScanFace, FileCheck2, ArrowRight } from "lucide-react";
import { TID } from "@/constants/coverifyIds";

const STEPS = [
  { icon: Send, title: "Send invite", desc: "Trigger a secure verification link by email or SMS, branded with your firm." },
  { icon: FileUp, title: "Client uploads ID", desc: "Passport, driving licence or national ID, captured on mobile or web." },
  { icon: ScanFace, title: "Biometric & liveness", desc: "Selfie matched to document. AI-driven liveness defeats spoofing attempts." },
  { icon: FileCheck2, title: "Audit-ready report", desc: "Signed PDF + status flags appear instantly against the client record." },
];

export default function VerificationFlow() {
  return (
    <section id="flow" className="py-20 md:py-28">
      <div className="container-cv">
        <div className="max-w-3xl">
          <span className="section-eyebrow">How it works</span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-primary tracking-tight leading-[1.1]">
            A four-step verification flow your clients will{" "}
            <span className="text-accent">actually finish.</span>
          </h2>
        </div>

        <div className="mt-14 relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute left-0 right-0 top-10 h-px bg-gradient-to-r from-transparent via-border to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 relative">
            {STEPS.map((s, i) => (
              <div
                key={i}
                data-testid={TID.flowStep(i + 1)}
                className="relative rounded-2xl border border-border bg-white p-6 hover:-translate-y-1 transition-transform"
              >
                <div className="flex items-center justify-between">
                  <div className="grid h-12 w-12 place-items-center rounded-xl bg-accent text-primary">
                    <s.icon className="h-6 w-6" />
                  </div>
                  <div className="font-display text-xs font-bold uppercase tracking-[0.18em] text-muted-foreground">
                    Step {String(i + 1).padStart(2, "0")}
                  </div>
                </div>
                <h3 className="mt-5 font-display text-lg font-bold text-primary tracking-tight">{s.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>

                {i < STEPS.length - 1 && (
                  <ArrowRight className="hidden md:block absolute -right-3 top-10 h-5 w-5 text-accent bg-background rounded-full" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
